var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',_vm._l((_vm.obj),function(sect){return _c('li',{key:sect.title},[_vm._v(_vm._s(sect.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }